<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px" size="small">

          </el-form>
          <!-- <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div> -->
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/staging'}">工作台</el-breadcrumb-item>
          <el-breadcrumb-item>{{ busiName }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100" v-loading="loading" style="width:100%">
          <!-- <el-table-column key="mul" type="selection" width="55" align="center" fixed="left"></el-table-column> -->
          <el-table-column prop="projectName" label="项目名称" min-width="170" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="taskContent" label="任务内容" min-width="170" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="taskAttachUrl" label="任务附件" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column prop="status" label="任务状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">
              <span v-if="row.status=='4'" style="color: red;font-weight: 600;">超期</span>
              <span v-if="row.status=='2'" style="color: orange;font-weight: 600;">处理中</span>
              <span v-if="row.status=='1'" style="color: blue;">待处理</span>
              <span v-if="row.status=='3'" style="color: green;">处理完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="tasker" label="任务人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="任务时限" min-width="200" :show-overflow-tooltip="true" align="center">
              <template slot-scope="{row}" v-if="row.TaskStartTime && row.TaskEndTime">{{ row.TaskStartTime.replace('T',' ') }} ~ {{ row.TaskEndTime.replace('T',' ') }} </template>
          </el-table-column>
          <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="agreedBillDate" label="约定开票日" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column v-if="busiName=='待发薪'" prop="name" label="约定发薪日" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="创建方式" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.autoGenerated ? '系统' : '人工' }}</template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.createTime ? row.createTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <!-- <el-table-column label="操作" fixed="right" align="center" width="220">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandle(row)">编辑</el-button>
                <el-button type="text" size="small">停用</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delHandle(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
              </div>
            </template>
          </el-table-column> -->
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount > 0" @current-change="currentChange" :current-page.sync="listQuery.pageNum" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 添加 -->
    <el-dialog title="添加" :visible.sync="addVisible" width="900px" class="res_dialog enter_dialog">
      <el-form ref="addForm" :inline="true" :model="addForm" :rules="rules" class="" label-width="100px" size="small"></el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAdd" :loading="isBtnLoading" size="small">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [],
          },
          projectId: '',
          busiId: ''
        },
        addForm: {

        },
        busiName: '',
        addVisible: false,
        isBtnLoading: false,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        showDropScreen: false,
        projectList: [], //项目列表
        multipleSelection: [],
        busiList: [{
            id: 1,
            busiName: '账单'
          },
          {
            id: 2,
            busiName: '开票'
          },
          {
            id: 3,
            busiName: '算薪'
          },
          {
            id: 4,
            busiName: '算薪异常'
          },
          {
            id: 5,
            busiName: '待发薪'
          },
          {
            id: 6,
            busiName: '发薪异常'
          },
          {
            id: 7,
            busiName: '确认零申报'
          },
          {
            id: 8,
            busiName: '月度报表'
          },
          {
            id: 9,
            busiName: '客户沟通'
          },
          {
            id: 10,
            busiName: '入职登记'
          },
          {
            id: 11,
            busiName: '入职审批'
          },
          {
            id: 12,
            busiName: '登记异常'
          },
          {
            id: 13,
            busiName: '发起签约'
          },
          {
            id: 14,
            busiName: '个人待签'
          },
          {
            id: 15,
            busiName: '签约待审'
          },
          {
            id: 16,
            busiName: '签约异常'
          },
          {
            id: 17,
            busiName: '商保参保'
          },
          {
            id: 18,
            busiName: '商保审核'
          },
          {
            id: 19,
            busiName: '社保参保'
          },
          {
            id: 20,
            busiName: '参保异常'
          },
          {
            id: 21,
            busiName: '离职登记'
          },
          {
            id: 22,
            busiName: '离职审批'
          },
          {
            id: 23,
            busiName: '商保减保'
          },
          {
            id: 24,
            busiName: '社保减保'
          },
          {
            id: 25,
            busiName: '商保审核'
          }
        ],
        rules: {
          bankName: {
            required: true,
            message: '请选择银行',
            trigger: 'change'
          },
        },
      }
    },
    created() {
      // this.getButtonPower();
      if (this.$route.query.busiName != undefined && this.$route.query.busiName) {
        this.busiName = this.$route.query.busiName;
        let item = this.busiList.find(item => item.busiName == this.$route.query.busiName);
        this.listQuery.busiId = item.id;
        this.getList();
      } else {
        this.listQuery.busiId = '';
        this.$message.error('参数异常！');
      }
    },
    methods: {
      checkPermission,
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ArdCurStat(this.listQuery, 'GetTaskEntityPageList').then(res => {
          if (res.status === 'ok') {
            console.log(this.tableData);
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
          } else {
            this.tableData = [];
            this.totalCount = 0;
          }
          this.loading = false;
        }).catch(error => {
          console.error('Error fetching task settings:', error);
          this.tableData = [];
          this.totalCount = 0;
          this.loading = false;
        });
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      editHandle(row) {
        this.type = 'edit'
        this.addForm = {}
        this.isBtnLoading = false;
        this.addVisible = true;
      },
      confirmAdd() {
        this.$refs.addTaskForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.ArdCurStat(this.addTaskForm, 'AddUpdataBusiBankTaskSetting').then(res => {
              if (res.status == 'ok') {
                this.getList();
                this.addVisible = false;
                this.isBtnLoading = false;
                this.$message.success('添加成功！')
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      stopHandel(status) {},
      delHandle(row) {
        let d = {
          id: row.id,
          isDeleted: true
        }
        this.loading = true;
        xz.ArdCurStat(d, 'AddUpdataBusiBankTaskSetting').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('删除成功！')
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })

      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .timeTitle {
    padding: 0 20px;
  }

  .timeItemTile {
    font-size: 16px;
    margin-bottom: 10px;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>